export default function Grid({ children }: { children: React.ReactNode }) {
  return <div className='grid'>{children}</div>
}
